<cm-breadcrumb>
    @for (item of items(); track $index) {
        <cm-breadcrumb-item>
            <a [routerLink]="item.route">{{ item.label }}</a>
        </cm-breadcrumb-item>
    }
</cm-breadcrumb>
